import { render } from "./NewsMailMaintenace.vue?vue&type=template&id=750915db&ts=true"
import script from "./NewsMailMaintenace.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsMailMaintenace.vue?vue&type=script&setup=true&lang=ts"

import "./NewsMailMaintenace.vue?vue&type=style&index=0&id=750915db&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/admin/NewsMailMaintenace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "750915db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('750915db', __exports__)) {
    console.log('reload')
    api.reload('750915db', __exports__)
  }
  
  module.hot.accept("./NewsMailMaintenace.vue?vue&type=template&id=750915db&ts=true", () => {
    console.log('re-render')
    api.rerender('750915db', render)
  })

}


export default __exports__